import {
    AGENT_MODEL_OPTIONS,
    AgentModelEffort,
    DEFAULT_AGENT_MODEL,
    getAgentModel,
    getAgentModelEfforts
} from 'shared/models/agent-model';

export { DEFAULT_AGENT_MODEL } from 'shared/models/agent-model';
export { normalizeAgentEffort } from 'shared/models/agent-model';

export type AgentEffort = AgentModelEffort;

export interface AgentRuntimeSelectOption {
    label: string;
    value: string;
}

export const DEFAULT_AGENT_EFFORT: AgentEffort = 'medium';
export const RETIRED_AGENT_MODEL_MESSAGE = 'This model is retired. Switch to another model to continue.';

export const getAgentModelOptions = (canUsePi: boolean) =>
    AGENT_MODEL_OPTIONS.filter((option) => canUsePi || option.runtime === 'claude');

export const normalizeAgentModel = (model: string, canUsePi: boolean) => {
    const option = getAgentModel(model);
    return option && (canUsePi || option.runtime === 'claude') ? option.value : DEFAULT_AGENT_MODEL;
};

export const getAgentEffortOptions = (model: string): AgentRuntimeSelectOption[] =>
    getAgentModelEfforts(model).map((effort) => ({
        label: effort.charAt(0).toUpperCase() + effort.slice(1),
        value: effort
    }));
